export default __webpack_public_path__ + "static/media/the-villa3.e9d84e47.webp";